import { useEffect, useState } from 'react'

import { useAppSelector } from '@/store/hook'
import { selectHasSessionBasedShoppingCart } from '@/store/selectors/userSelector'
import { getSessionCookieKey } from '@/contexts/punchout/sessionCookieKeyStore'
import { SESSION_BASED_EXPIRY_TIME } from '@/libs/constants'
import { getCookieData, renewCookie } from '@/libs/utils/cookies'
import { compareObjects, isEmptyObject } from '@/libs/utils/object'

const useSessionBased = () => {
  const hasSessionBased = useAppSelector(selectHasSessionBasedShoppingCart)
  const [cookieValue, setCookieValue] = useState(null)

  useEffect(() => {
    async function setInitialCookieValue() {
      const cookie = await getCookieData(getSessionCookieKey())
      setCookieValue(cookie)
    }
    void setInitialCookieValue()
  }, [])

  useEffect(() => {
    const intervalId = setInterval(async () => {
      const currentCookieValue = await getCookieData(getSessionCookieKey())
      if (
        !isEmptyObject(cookieValue)
        && !isEmptyObject(currentCookieValue)
        && compareObjects(cookieValue, currentCookieValue)
      ) {
        setCookieValue(currentCookieValue)
        if (currentCookieValue?.value) {
          renewCookie(getSessionCookieKey(), SESSION_BASED_EXPIRY_TIME)
        }
      }
    }, 5000)

    if (!hasSessionBased) {
      clearInterval(intervalId)
    }
    return () => {
      clearInterval(intervalId)
    }
  }, [cookieValue, hasSessionBased])

  return { sessionId: cookieValue?.value, hasSessionBased }
}

export default useSessionBased
